module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel_01-0ae6bc16a3abcd6b54b11b7b753b5d94.jpg";